import { RichOption } from '@liscio/api';

/**
 * Matches refactor `showIndividualAdditionInformationForm` — compares entity_type
 * to home `individual_entity_type` options by value (case-insensitive).
 */
export function isIndividualEntityType(
  entityType: string | undefined,
  individualEntityTypes: RichOption[]
): boolean {
  if (!entityType) {
    return false;
  }

  const normalized = entityType.toLowerCase();

  return individualEntityTypes.some((option) => {
    const value = option.value != null ? String(option.value).toLowerCase() : '';
    const key = option.key != null ? String(option.key).toLowerCase() : '';
    return value === normalized || key === normalized;
  });
}

export function getCreateAccountFormSectionVisibility({
  entityType,
  individualEntityTypes,
  firmType,
}: {
  entityType?: string;
  individualEntityTypes: RichOption[];
  firmType?: string;
}) {
  const isIndividual = isIndividualEntityType(entityType, individualEntityTypes);
  // When firm_type is absent from home payload, default to CPA sections (refactor assumes CPA app).
  const normalizedFirmType = firmType?.trim().toLowerCase();
  const isCpaFirm = !normalizedFirmType || normalizedFirmType === 'cpa';

  // Refactor shows business sections when not individual (including before entity_type is set).
  const showBusinessSections = !isIndividual;

  return {
    entityType,
    isIndividual,
    isBusiness: !isIndividual,
    isCpaFirm,
    showBusinessSections,
    showCpaBusinessSections: showBusinessSections && isCpaFirm,
    showIndividualSections: isIndividual,
  };
}
